import React, { useEffect } from 'react'
import {
  useDispatch,
  useSelector,
} from 'react-redux'

import { getQuoteRequestValue } from 'state/quotes/selectors'
import { setIsQuoteRequestedEventSent } from 'state/analytics/actions'
import type { RootState } from 'state/types'

import Medicare from './index.presentational'

const MedicareContainer: React.FC = (): React.ReactElement => {
  const applicantFirstName = useSelector((state: RootState) => (getQuoteRequestValue(state, 'applicant.personalInfo.name.firstName')))

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setIsQuoteRequestedEventSent({
      insuranceType: 'medicare',
      isQuoteRequestedEventSent: false,
    }))
  }, [ dispatch ])

  return React.createElement(
    Medicare,
    { applicantFirstName },
  )
}

export default MedicareContainer
